import { createAction, createPayloadAction } from '../../../core/helpers'

import { LOGOUT, UPDATE_ACCESS_TOKEN } from '../action-types'

export const logout = createAction(LOGOUT)
export const updateAccessToken = createPayloadAction(UPDATE_ACCESS_TOKEN)
